import React, { useEffect, useState } from 'react';
import { DS } from './ds';
const DRAW_DONE = 2400;
const PAUSE_END = 3900;
const FADE_END = 4500;
export function PageLoader() {
  const [phase, setPhase] = useState<'drawing' | 'pause' | 'fadeout' | 'done'>('drawing');
  const [hasStarted, setHasStarted] = useState(false);
  useEffect(() => {
    const frame = window.requestAnimationFrame(() => setHasStarted(true));
    const pauseTimer = window.setTimeout(() => setPhase('pause'), DRAW_DONE);
    const fadeTimer = window.setTimeout(() => setPhase('fadeout'), PAUSE_END);
    const doneTimer = window.setTimeout(() => setPhase('done'), FADE_END);
    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(pauseTimer);
      window.clearTimeout(fadeTimer);
      window.clearTimeout(doneTimer);
    };
  }, []);
  if (phase === 'done') return null;
  return <div role="status" aria-label="Cargando Alinova" style={{
    position: 'fixed',
    inset: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 10001,
    background: DS.color.ivory,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: phase === 'fadeout' ? 0 : 1,
    transform: phase === 'fadeout' ? 'scale(1.04)' : 'scale(1)',
    transition: phase === 'fadeout' ? 'opacity 600ms cubic-bezier(0.4,0,0.2,1), transform 600ms cubic-bezier(0.4,0,0.2,1)' : 'none',
    pointerEvents: phase === 'fadeout' ? 'none' : 'all'
  }} data-id="element-80" data-mp="2s9lhgddmoc63">
      {/* Wrapper centrado */}
      <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0px'
    }} data-id="element-81" data-mp="1yviwcokjntmv">
        {/* Ícono */}
        <img src="https://cdn.magicpatterns.com/uploads/eCCStZw4PgHMG4Eqg3YNhv/Icono_Alinova.svg" alt="" aria-hidden="true" style={{
        display: 'block',
        width: '220px',
        height: '220px',
        objectFit: 'contain',
        opacity: hasStarted ? 1 : 0,
        transform: hasStarted ? 'scale(1)' : 'scale(0.9)',
        transition: 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)'
      }} data-id="element-82" data-mp="2qm6qvhrpq0rk" />

        {/* Nombre */}
        <div style={{
        fontFamily: DS.font.heading,
        fontWeight: 700,
        fontSize: '1.9rem',
        letterSpacing: '0.14em',
        color: DS.color.tealDeep,
        textTransform: 'uppercase',
        textAlign: 'center',
        marginTop: '8px',
        opacity: hasStarted ? 1 : 0,
        transform: hasStarted ? 'translateY(0)' : 'translateY(10px)',
        transition: 'opacity 0.6s ease 2.3s, transform 0.6s ease 2.3s'
      }} data-id="element-83" data-mp="2mcmft6a9u5ip">
          Alinova
        </div>

        {/* Eslogan */}
        <div style={{
        fontFamily: DS.font.body,
        fontSize: '0.72rem',
        letterSpacing: '0.22em',
        color: DS.color.muted,
        textTransform: 'uppercase',
        textAlign: 'center',
        marginTop: '8px',
        opacity: hasStarted ? 1 : 0,
        transition: 'opacity 0.5s ease 2.45s'
      }} data-id="element-84" data-mp="1oil977uecmv2">
          En línea con tu sonrisa
        </div>

        {/* Barra de progreso */}
        <div style={{
        marginTop: '36px',
        width: '120px',
        height: '2px',
        borderRadius: '2px',
        background: `${DS.color.aqua}25`,
        overflow: 'hidden'
      }} data-id="element-85" data-mp="1aqoin88dml0s">
          <div style={{
          height: '100%',
          borderRadius: '2px',
          background: `linear-gradient(90deg, ${DS.color.teal}, ${DS.color.aqua})`,
          width: hasStarted ? '100%' : '0%',
          transition: `width ${DRAW_DONE}ms cubic-bezier(0.4, 0, 0.2, 1)`
        }} data-id="element-86" data-mp="1kh9mpb6tkhr3" />
        </div>
      </div>
    </div>;
}